//
// locales/vanilla/fa.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/fa.json';
import localeData from 'react-intl/locale-data/fa.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
